import ModulePay from "@/page/modules/pay/pay";
import ModuleWXPay from "@/page/modules/pay/wxPay";
import ModulePayResult from "@/page/modules/pay/result";
import Index from "@/page/continueEdu/index";
import Home from "@/page/continueEdu/home";

/* 继续教育机构管理org路由 */
import PageOrg from "@/page/continueEdu/org/index";
import PageOrgStructure from "@/page/byl/org/structure/index";
import PageOrgReports from "@/page/byl/org/reports/index";
import PageOrgExternals from "@/page/byl/org/externals/index";
import PageOrgGroup from "@/page/byl/org/group/index";
import PageOrgResource from "@/page/byl/org/resource/model";
import PageOrgResourceList from "@/page/byl/org/resource/list";
import PageOrgRepo from "@/page/byl/org/repo/model";
import PageOrgRepoList from "@/page/byl/org/repo/list";
import PageOrgTag from "@/page/byl/org/tag/model";
import PageOrgTagList from "@/page/byl/org/tag/list";
import PageOrgMsg from "@/page/byl/org/msg/model";
import PageOrgMsgList from "@/page/byl/org/msg/list";
import PageOrgCourse from "@/page/byl/org/course/model";
import PageOrgCourseList from "@/page/byl/org/course/list";
import PageOrgLivePlay from "@/page/byl/org/livePlay/model";
import PageOrgLivePlayList from "@/page/byl/org/livePlay/list";
import PageOrgBanner from "@/page/byl/org/banner/model";
import PageOrgBannerList from "@/page/byl/org/banner/list";
import PageMenu from "@/page/byl/org/orgmenu/model";
import PageMenuList from "@/page/byl/org/orgmenu/list";
import PageOrgRole from "@/page/byl/org/role/model";
import PageOrgRoleList from "@/page/byl/org/role/list";
import PageOrgRoleDistributeList from "@/page/byl/org/role/distribute";
import PageRole from "@/page/byl/org/orgrole/model";
import PageRoleList from "@/page/byl/org/orgrole/list";
import PageRoleDistributeList from "@/page/byl/org/orgrole/distribute";
import PageDictList from "@/page/byl/org/orgdict/list";
import PageDict from "@/page/byl/org/orgdict/model";
import PageOrgAppList from "@/page/byl/org/appmgt/list";
import PageOrgApp from "@/page/byl/org/appmgt/model";
/* 考试-考卷-考题-问卷--start */
import ModuleExamReady from "@/page/continueEdu/exam/ready";
import ModuleExamStart from "@/page/continueEdu/exam/start";
import ModuleExamAnalysis from "@/page/continueEdu/exam/analysis";
import ModuleExamResult from "@/page/continueEdu/exam/result";

import ModuleQuestionnaireStart from "@/page/continueEdu/questionnaire/start";
import ModuleQuestionnaireResult from "@/page/continueEdu/questionnaire/result";

import PageOrgExamPaper from "@/page/byl/org/examination_paper/model";
import PageOrgExamPaperList from "@/page/byl/org/examination_paper/list";
import PageOrgExamPaperScoreList from "@/page/byl/org/examination_paper/scoreList";
import PageOrgExamPaperScoreByTeacher from "@/page/byl/org/examination_paper/scoreByTeacher";
import PageOrgExamPaperAnswerList from "@/page/byl/org/examination_paper/answerList";
import PageOrgExamClassification_f from "@/page/byl/org/examination_paper/classification_f";
import PageOrgExamClassification_s from "@/page/byl/org/examination_paper/classification_s";
import PageOrgExamClassification_relate from "@/page/byl/org/examination_paper/classification_relate";

import PageOrgExamQuestionList from "@/page/byl/org/examination_question/list";
import PageOrgExamQ_ShortAnswer from "@/page/byl/org/examination_question/model_shortAnswer";
import PageOrgExamQ_Judgment from "@/page/byl/org/examination_question/model_judgment";
import PageOrgExamQ_Completion from "@/page/byl/org/examination_question/model_completion";
import PageOrgExamQ_Choice from "@/page/byl/org/examination_question/model_choice";
import PageOrgExamQ_MultipleChoice from "@/page/byl/org/examination_question/model_multipleChoice";

import PageOrgExamQClassification_f from "@/page/byl/org/examination_question/classification_f";
import PageOrgExamQClassification_s from "@/page/byl/org/examination_question/classification_s";
import PageOrgExamQClassification_relate from "@/page/byl/org/examination_question/classification_relate";

import PageOrgQuestionnaire from "@/page/byl/org/questionnaire/model";
import PageOrgQuestionnaireStat from "@/page/byl/org/questionnaire/statistics";
import PageOrgQuestionnaireList from "@/page/byl/org/questionnaire/list";
/* 考试-考卷-考题-问卷--end */
import PageOrgTeacher from "@/page/byl/org/teacher/model";
import PageOrgTeacherList from "@/page/byl/org/teacher/list";
import PageOrgEnroll from "@/page/byl/org/enroll/model";
import PageOrgEnrollList from "@/page/byl/org/enroll/list";
import PageOrgEnrollConfirm from "@/page/byl/org/enroll/confirm";
import PageOrgEnrollAudit from "@/page/byl/org/enroll/audit";
import PageOrgEnrollCheck from "@/page/byl/org/enroll/check";
import PageOrgCert from "@/page/byl/org/cert/model";
import PageOrgCertList from "@/page/byl/org/cert/list";
import PageOrgSendCert from "@/page/byl/org/cert/send";
import PageOrgCertRecord from "@/page/byl/org/cert/record";
import PageOrgPlan from "@/page/byl/org/plan/model";
import PageOrgPlanList from "@/page/byl/org/plan/list";
import PageOrgInformation from "@/page/byl/org/information/model";
import PageOrgInformationList from "@/page/byl/org/information/list";
import PageUserList from "@/page/byl/org/user/list";
import PageOrgInfo from "@/page/byl/org/orginfo/list";

import ModuleTeacherDetail from "@/page/continueEdu/teacher/model";
import CourseList from "@/page/continueEdu/course/list";
import Course from "@/page/continueEdu/course/model";
import LivePlay from "@/page/continueEdu/liveplay/model";
import PlanList from "@/page/continueEdu/plan/list";
import Plan from "@/page/continueEdu/plan/detail";
import PlanRecord from "@/page/continueEdu/plan/record";
import TrainList from "@/page/continueEdu/train/list";
import Train from "@/page/continueEdu/train/model";
import EnrollList from "@/page/continueEdu/enroll/list";
import Enroll from "@/page/continueEdu/enroll/detail";
import NewsList from "@/page/continueEdu/news/list";
import News from "@/page/continueEdu/news/model";
import TaskList from "@/page/continueEdu/task/index";
import myCourse from "@/page/modules/task/myCourse";
import myPlan from "@/page/modules/task/myPlan";
import myEnroll from "@/page/modules/task/myEnroll";
import myExamination from "@/page/modules/task/myExam";
import myQuiz from "@/page/modules/task/myQTest";
import UC from "@/page/continueEdu/uc/index";
import Record from "@/page/modules/uc/record";
import Fav from "@/page/modules/uc/fav";
import Examination from "@/page/modules/uc/examination";
import EnrollUC from "@/page/modules/uc/enroll";
import Certificate from "@/page/modules/uc/certificate";
import Message from "@/page/modules/uc/message";
import Set from "@/page/modules/uc/set";
import Order from "@/page/modules/uc/order";
import Invoice from "@/page/modules/uc/invoice";
import LearnRecord from "@/page/modules/uc/learnrecord";
const routes = [
  {
    path: "/continueEdu/index",
    component: Index,
    redirect: "/continueEdu/home",
    children: [
      {
        path: "/continueEdu/home",
        name: "职称教育首页",
        component: Home,
      },
      {
        path: "/continueEdu/wxPay",
        name: "微信支付(职称教育)",
        component: ModuleWXPay,
      },
      {
        path: "/continueEdu/payResult/:type/:businessId/:res_url",
        name: "购买结果(职称教育)",
        component: ModulePayResult,
      },
      {
        path: "/continueEdu/courseList",
        name: "课程学习",
        component: CourseList,
      },
      {
        name: "继续教育课程详情",
        path: "/continueEdu/courseDetail/:id",
        component: Course,
        meta: {
          navClass: "/continueEdu/courseList", // 为了实现点击到详情页时维持顶部导航栏选中的状态
        },
      },
      {
        path: "/continueEdu/coursePay/:id/:type/:businessId/:orgType/:result_url/:sign",
        name: "课程购买(继续教育)",
        component: ModulePay,
      },
      {
        path: "/continueEdu/planList",
        name: "培训计划",
        component: PlanList,
      },
      {
        name: "培训计划详情",
        path: "/continueEdu/plan/:id",
        component: Plan,
        meta: {
          navClass: "/continueEdu/planList", // 为了实现点击到详情页时维持顶部导航栏选中的状态
        },
      },
      {
        path: "/continueEdu/teacherDetail/:id",
        name: "讲师详情(继续教育)",
        component: ModuleTeacherDetail,
        meta: {
          prefix: "/continueEdu",
        },
      },
      {
        name: "培训计划进度",
        path: "/continueEdu/planrecord/:id/:planId",
        component: PlanRecord,
        meta: {
          navClass: "/continueEdu/planList", // 为了实现点击到详情页时维持顶部导航栏选中的状态
        },
      },
      {
        path: "/continueEdu/planPay/:id/:type/:businessId/:orgType/:result_url/:sign",
        name: "培训计划购买",
        component: ModulePay,
        meta: {
          navClass: "/continueEdu/planList", // 为了实现点击到详情页时维持顶部导航栏选中的状态
        },
      },
      {
        path: "/continueEdu/examReady/:id/:type",
        name: "开始考试(继续教育)",
        component: ModuleExamReady,
      },
      {
        path: "/continueEdu/examStart/:id/:examId",
        name: "考试页面(继续教育)",
        component: ModuleExamStart,
      },
      {
        path: "/continueEdu/questionnaireStart/:id/:type/:paperId",
        name: "问卷页面(继续教育)",
        component: ModuleQuestionnaireStart,
      },
      {
        path: "/continueEdu/questionnaireResult/:id/:type",
        name: "问卷结果(继续教育)",
        component: ModuleQuestionnaireResult,
      },
      {
        path: "/continueEdu/examAnalysis/:id/:examId/:infoId",
        name: "考试分析(继续教育)",
        component: ModuleExamAnalysis,
      },
      {
        path: "/continueEdu/examResult/:examId",
        name: "考试结果(继续教育)",
        component: ModuleExamResult,
      },
      {
        path: "/continueEdu/trainList",
        name: "培训信息",
        component: TrainList,
      },
      {
        name: "培训信息详情",
        path: "/continueEdu/train/:id",
        component: Train,
        meta: {
          navClass: "/continueEdu/trainList", // 为了实现点击到详情页时维持顶部导航栏选中的状态
        },
      },
      {
        path: "/continueEdu/enrollList",
        name: "报名中心",
        component: EnrollList,
        meta: {
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/enroll/:id",
        name: "报名",
        component: Enroll,
        meta: {
          navClass: "/continueEdu/enrollList", // 为了实现点击到详情页时维持顶部导航栏选中的状态
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/enrollPay/:id/:type/:businessId/:orgType/:result_url/:sign",
        name: "报名购买",
        component: ModulePay,
        meta: {
          navClass: "/continueEdu/enrollList", // 为了实现点击到详情页时维持顶部导航栏选中的状态
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/newsList",
        name: "新闻资讯",
        component: NewsList,
      },
      {
        name: "新闻资讯详情",
        path: "/continueEdu/news/:id",
        component: News,
        meta: {
          navClass: "/continueEdu/newsList", // 为了实现点击到详情页时维持顶部导航栏选中的状态
        },
      },
      {
        name: "直播课程详情（继续教育）",
        path: "/continueEdu/livePlayDetail/:id",
        component: LivePlay,
        meta: {
          navClass: "/continueEdu/livePlayList", // 为了实现点击到详情页时维持顶部导航栏选中的状态
        },
      },
      {
        path: "/continueEdu/livePlayPay/:id/:type/:businessId/:orgType/:result_url/:sign",
        name: "直播购买(继续教育)",
        component: ModulePay,
        meta: {
          prefix: "/continueEdu",
        },
      },
      {
        name: "任务中心",
        path: "/continueEdu/taskList",
        component: TaskList,
        redirect: "/continueEdu/taskList/course",
        children: [
          {
            path: "/continueEdu/taskList/course",
            name: "myCourse",
            component: myCourse,
          },
          {
            path: "/continueEdu/taskList/plan",
            name: "myPlan",
            component: myPlan,
          },
          {
            path: "/continueEdu/taskList/exam",
            name: "myExamination",
            component: myExamination,
          },
          {
            path: "/continueEdu/taskList/quiz",
            name: "myQuiz",
            component: myQuiz,
          },
          {
            path: "/continueEdu/taskList/enroll",
            name: "myEnroll",
            component: myEnroll,
            meta: {
              prefix: "/continueEdu",
            },
          },
        ],
      },
      {
        path: "/continueEdu/uc",
        name: "继续教育个人中心",
        component: UC,
        children: [
          {
            path: "/continueEdu/uc/record",
            name: "继续教育个人中心学习记录",
            component: Record,
          },
          {
            path: "/continueEdu/uc/fav",
            name: "继续教育个人中心我的收藏",
            component: Fav,
          },
          {
            path: "/continueEdu/uc/examination",
            name: "继续教育个人中心我的考试",
            component: Examination,
          },
          {
            path: "/continueEdu/uc/enroll",
            name: "继续教育个人中心我的报名",
            component: EnrollUC,
            meta: {
              prefix: "/continueEdu",
            },
          },
          {
            path: "/continueEdu/uc/certificate",
            name: "继续教育个人中心我的证书",
            component: Certificate,
          },
          {
            path: "/continueEdu/uc/message",
            name: "继续教育个人中心我的消息",
            component: Message,
          },
          {
            path: "/continueEdu/uc/set",
            name: "继续教育个人中心系统设置",
            component: Set,
          },
          {
            path: "/continueEdu/uc/order",
            name: "继续教育个人中心我的订单",
            component: Order,
            meta: {
              prefix: "/continueEdu",
            },
          },
          {
            path: "/continueEdu/uc/invoice",
            name: "继续教育个人中心我的开票",
            component: Invoice,
            meta: {
              prefix: "/continueEdu",
            },
          },
          {
            path: "/continueEdu/uc/lrecord",
            name: "继续教育个人中心我的学时",
            component: LearnRecord,
            meta: {
              prefix: "/continueEdu",
            },
          },
        ],
      },
    ],
  },
  {
    path: "/continueEdu/org",
    component: PageOrg,
    redirect: "/continueEdu/org/entinfo",
    children: [
      {
        path: "/continueEdu/org/structure",
        name: "组织架构（继续教育）",
        component: PageOrgStructure,
        meta: {
          title: "组织架构",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/reports",
        name: "报表预览（继续教育）",
        component: PageOrgReports,
        meta: {
          title: "报表预览",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/externals",
        name: "外部系统(继续教育)",
        component: PageOrgExternals,
        meta: {
          title: "外部系统",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/group",
        name: "小组管理（继续教育）",
        component: PageOrgGroup,
        meta: {
          title: "小组管理",
          prefix: "/continueEdu",
        },
      },
      {
        name: "消息管理(继续教育)",
        path: "/continueEdu/org/msgList",
        component: PageOrgMsgList,
        meta: {
          title: "消息管理",
          prefix: "/continueEdu",
        },
      },
      {
        name: "消息发送（继续教育）",
        path: "/continueEdu/org/msg",
        component: PageOrgMsg,
        meta: {
          title: "消息发送",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/tag/:id",
        name: "标签详情(继续教育)",
        component: PageOrgTag,
        meta: {
          title: "标签管理",
          description: "标签管理",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/tagList",
        name: "标签管理(继续教育)",
        component: PageOrgTagList,
        meta: {
          title: "标签管理",
          description: "标签管理",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/resource/:id",
        name: "课件资源详情（继续教育）",
        component: PageOrgResource,
        meta: {
          title: "课件资源管理",
          description: "课件资源管理",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/resourceList",
        name: "课件资源管理（继续教育）",
        component: PageOrgResourceList,
        meta: {
          title: "课件资源管理",
          description: "课件资源管理",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/repo/:id",
        name: "知识库详情（继续教育）",
        component: PageOrgRepo,
        meta: {
          title: "知识库管理",
          description: "知识库管理",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/repoList",
        name: "知识库管理（继续教育）",
        component: PageOrgRepoList,
        meta: {
          title: "知识库管理",
          description: "知识库管理",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/course/:id",
        name: "课程编辑（继续教育）",
        component: PageOrgCourse,
        meta: {
          title: "课程管理",
          description: "课程管理",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/courseList",
        name: "课程管理（继续教育）",
        component: PageOrgCourseList,
        meta: {
          title: "课程管理",
          description: "课程管理",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/livePlay/:id",
        name: "直播编辑（继续教育）",
        component: PageOrgLivePlay,
        meta: {
          title: "直播管理",
          description: "直播管理",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/livePlayList",
        name: "直播管理（继续教育）",
        component: PageOrgLivePlayList,
        meta: {
          title: "直播管理",
          description: "直播管理",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/questionnaire/:id",
        name: "问卷编辑（继续教育）",
        component: PageOrgQuestionnaire,
        meta: {
          title: "问卷管理",
          description: "问卷管理",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/questionnaireStat/:id",
        name: "问卷统计（继续教育）",
        component: PageOrgQuestionnaireStat,
        meta: {
          title: "问卷管理",
          description: "问卷管理",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/questionnaireList",
        name: "问卷管理（继续教育）",
        component: PageOrgQuestionnaireList,
        meta: {
          title: "问卷管理",
          description: "问卷管理",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/examPaper/:id",
        name: "考卷编辑（继续教育）",
        component: PageOrgExamPaper,
        meta: {
          title: "考卷管理",
          description: "考卷管理",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/examPaperList",
        name: "考卷管理（继续教育）",
        component: PageOrgExamPaperList,
        meta: {
          title: "考卷管理",
          description: "考卷管理",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/examPaperScoreList/:id",
        name: "考卷成绩一览（继续教育）",
        component: PageOrgExamPaperScoreList,
        meta: {
          title: "考卷成绩一览",
          description: "考卷成绩一览",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/examPaperScoreByTeacher/:examId/:paperId",
        name: "老师评分（继续教育）",
        component: PageOrgExamPaperScoreByTeacher,
        meta: {
          title: "老师评分",
          description: "老师评分",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/examPaperAnswerList/:id",
        name: "考卷成绩回答一览（继续教育）",
        component: PageOrgExamPaperAnswerList,
        meta: {
          title: "考卷成绩回答一览",
          description: "考卷成绩回答一览",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/examClassification_f/:path/:id",
        name: "大分类管理（继续教育）",
        component: PageOrgExamClassification_f,
        meta: {
          title: "大分类管理",
          description: "大分类管理",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/examClassification_s/:path/:id",
        name: "小分类管理（继续教育）",
        component: PageOrgExamClassification_s,
        meta: {
          title: "小分类管理",
          description: "小分类管理",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/examClassification_relate/:path/:id/:fValue/:fLabel",
        name: "分类关联（继续教育）",
        component: PageOrgExamClassification_relate,
        meta: {
          title: "分类关联",
          description: "分类关联",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/examQuestionList",
        name: "考题管理（继续教育）",
        component: PageOrgExamQuestionList,
        meta: {
          title: "考题管理",
          description: "考题管理",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/examQClassification_f/:path/:id",
        name: "考题大分类管理(继续教育)",
        component: PageOrgExamQClassification_f,
        meta: {
          title: "大分类管理",
          description: "大分类管理",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/examQClassification_s/:path/:id",
        name: "考题小分类管理(继续教育)",
        component: PageOrgExamQClassification_s,
        meta: {
          title: "小分类管理",
          description: "小分类管理",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/examQClassification_relate/:path/:id/:fValue/:fLabel",
        name: "考题分类关联(继续教育)",
        component: PageOrgExamQClassification_relate,
        meta: {
          title: "分类关联",
          description: "分类关联",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/examQuestionShortAnswer/:id",
        name: "简答题编辑（继续教育）",
        component: PageOrgExamQ_ShortAnswer,
        meta: {
          title: "简答题编辑",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/examQuestionCompletion/:id",
        name: "填空题编辑（继续教育）",
        component: PageOrgExamQ_Completion,
        meta: {
          title: "填空题编辑",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/examQuestionChoice/:id",
        name: "选择题编辑（继续教育）",
        component: PageOrgExamQ_Choice,
        meta: {
          title: "选择题编辑",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/examQuestionJudgment/:id",
        name: "判断题编辑（继续教育）",
        component: PageOrgExamQ_Judgment,
        meta: {
          title: "判断题编辑",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/examQuestionMultipleChoice/:id",
        name: "多选题编辑（继续教育）",
        component: PageOrgExamQ_MultipleChoice,
        meta: {
          title: "多选题编辑",
          prefix: "/continueEdu",
        },
      },
      {
        name: "培训计划管理（继续教育）",
        path: "/continueEdu/org/planList",
        component: PageOrgPlanList,
        meta: {
          title: "培训计划管理",
          description: "培训计划管理",
          prefix: "/continueEdu",
        },
      },
      {
        name: "培训计划详情（继续教育）",
        path: "/continueEdu/org/plan/:id",
        component: PageOrgPlan,
        meta: {
          title: "培训计划管理",
          description: "培训计划管理",
          prefix: "/continueEdu",
        },
      },
      {
        name: "报名管理（继续教育）",
        path: "/continueEdu/org/enrollList",
        component: PageOrgEnrollList,
        meta: {
          title: "报名管理",
          description: "报名管理",
          prefix: "/continueEdu",
        },
      },
      {
        name: "报名管理详情（继续教育）",
        path: "/continueEdu/org/enroll/:id",
        component: PageOrgEnroll,
        meta: {
          title: "报名管理",
          description: "报名管理",
          prefix: "/continueEdu",
        },
      },
      {
        name: "报名人员列表（继续教育）",
        path: "/continueEdu/org/enrollConfirm/:id",
        component: PageOrgEnrollConfirm,
        meta: {
          title: "报名管理",
          description: "报名管理",
          prefix: "/continueEdu",
        },
      },
      {
        name: "报名审核（继续教育）",
        path: "/continueEdu/org/enrollAudit/:id",
        component: PageOrgEnrollAudit,
        meta: {
          title: "报名审核",
          description: "报名审核",
          prefix: "/continueEdu",
        },
      },
      {
        name: "报名签到（继续教育）",
        path: "/continueEdu/org/enrollCheck/:id",
        component: PageOrgEnrollCheck,
        meta: {
          title: "报名签到",
          description: "报名签到",
          prefix: "/continueEdu",
        },
      },
      {
        name: "证书管理（继续教育）",
        path: "/continueEdu/org/certList",
        component: PageOrgCertList,
        meta: {
          title: "证书管理",
          description: "证书管理",
          prefix: "/continueEdu",
        },
      },
      {
        name: "证书管理详情（继续教育）",
        path: "/continueEdu/org/cert/:id",
        component: PageOrgCert,
        meta: {
          title: "证书管理",
          description: "证书管理",
          prefix: "/continueEdu",
        },
      },
      {
        name: "发证书(继续教育)",
        path: "/continueEdu/org/sendcert",
        component: PageOrgSendCert,
        meta: {
          title: "发证书",
          description: "发证书",
          prefix: "/continueEdu",
        },
      },
      {
        name: "发证记录(继续教育)",
        path: "/continueEdu/org/certrecord",
        component: PageOrgCertRecord,
        meta: {
          title: "发证记录",
          description: "发证记录",
          prefix: "/continueEdu",
        },
      },
      {
        name: "讲师管理（继续教育）",
        path: "/continueEdu/org/teacherList",
        component: PageOrgTeacherList,
        meta: {
          title: "讲师管理",
          description: "讲师管理",
          prefix: "/continueEdu",
        },
      },
      {
        name: "讲师管理详情（继续教育）",
        path: "/continueEdu/org/teacher/:id",
        component: PageOrgTeacher,
        meta: {
          title: "讲师管理",
          description: "讲师管理",
          prefix: "/continueEdu",
        },
      },
      {
        name: "公告管理（继续教育）",
        path: "/continueEdu/org/informationList",
        component: PageOrgInformationList,
        meta: {
          title: "公告管理",
          description: "公告管理",
          prefix: "/continueEdu",
        },
      },
      {
        name: "公告管理详情（继续教育）",
        path: "/continueEdu/org/information/:id",
        component: PageOrgInformation,
        meta: {
          title: "公告管理",
          description: "公告管理",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/bannerList",
        name: "推荐列表（继续教育）",
        component: PageOrgBannerList,
        meta: {
          title: "推荐管理",
          description: "推荐管理",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/banner/:id",
        name: "推荐详情（继续教育）",
        component: PageOrgBanner,
        meta: {
          title: "推荐管理",
          description: "推荐管理",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/menuList",
        name: "菜单管理（继续教育）",
        component: PageMenuList,
        meta: {
          title: "菜单管理",
          description: "菜单管理",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/menu/:id/:parentId",
        name: "菜单管理详情（继续教育）",
        component: PageMenu,
        meta: {
          title: "菜单管理",
          description: "菜单管理",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/orgroleList",
        name: "机构角色管理（继续教育）",
        component: PageOrgRoleList,
        meta: {
          title: "机构角色管理",
          description: "机构角色管理",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/orgrole/:id",
        name: "机构角色编辑(继续教育)",
        component: PageOrgRole,
        meta: {
          title: "机构角色编辑",
          description: "机构角色编辑",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/orgrole/distribute/:id",
        name: "机构角色分配管理(继续教育)",
        component: PageOrgRoleDistributeList,
        meta: {
          title: "机构角色分配管理",
          description: "机构角色分配管理",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/roleList",
        name: "角色管理（继续教育）",
        component: PageRoleList,
        meta: {
          title: "角色管理",
          description: "角色管理",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/role/:id",
        name: "角色管理详情（继续教育）",
        component: PageRole,
        meta: {
          title: "角色管理",
          description: "角色管理",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/role/distribute/:id",
        name: "角色管理分配（继续教育）",
        component: PageRoleDistributeList,
        meta: {
          title: "角色管理",
          description: "角色管理",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/dictList",
        name: "字典管理（继续教育）",
        component: PageDictList,
        meta: {
          title: "字典管理",
          description: "字典管理",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/dict/:id",
        name: "字典管理详情（继续教育）",
        component: PageDict,
        meta: {
          title: "字典管理",
          description: "字典管理",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/userList",
        name: "用户管理（继续教育）",
        component: PageUserList,
        meta: {
          title: "用户管理",
          description: "用户管理",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/entinfo",
        name: "机构信息管理(继续教育)",
        component: PageOrgInfo,
        meta: {
          title: "机构信息管理",
          description: "机构信息管理",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/appmgtList",
        name: "APP管理(继续教育)",
        component: PageOrgAppList,
        meta: {
          title: "APP管理",
          description: "APP管理",
          prefix: "/continueEdu",
        },
      },
      {
        path: "/continueEdu/org/appmgt/:id",
        name: "APP版本编辑(继续教育)",
        component: PageOrgApp,
        meta: {
          title: "APP版本编辑",
          description: "APP版本编辑",
          prefix: "/continueEdu",
        },
      },
    ],
  },
];

export default {
  routes,
};



// WEBPACK FOOTER //
// ./src/router/router-continueEdu.js